<template>
    <tr>
        <td>{{title}} <slot name="dealer" /></td>
        <td>
          <v-switch
            :color="themeColor"
            v-model="valueActive"
            @click.prevent="openModal(valueActive)"
          />
          <span v-if="valueActive"> Activo</span>
          <span v-else> Inactivo</span>
        </td>
    </tr>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        title: {
            default: '',
            required: true,
        },
        valueActive: {
            default: false,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            themeColor: 'theme/themeColor',
        }),
    },
    methods: {
        openModal(active) {
            this.$emit('showModal', active);
        },
    },
};
</script>

<style>

</style>
